// extracted by mini-css-extract-plugin
export default {"page-choice-panel":"KitDeXuatDanhGia_page-choice-panel__2lbG-"};